import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryPurchasedLiveEventsTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    events: t('events_purchased'),
  })
)
